import { ObjectStatusBadge } from "@molecules"

import styles from "./StatusCell.module.scss"
import { StatusCellProps } from "./StatusCell.types"

export default function StatusCell(props: StatusCellProps) {
    return (
        <div className={styles.base}>
            <ObjectStatusBadge {...props} size="sm" />
        </div>
    )
}
